import { atom } from "jotai";

export const isPotreeFocuesAtom = atom<any | null>(null);